import {
  RadioButtonGroupConfig,
  RadioButtonGroupItem,
} from '@/game/GameComponents/PhaserGame/Types/UITypes/RadioButtonTypes';
import RadioButton from '@/game/prefabs/RadioButton/RadioButton';

export default class RadioButtonGroup {
  constructor(config: RadioButtonGroupConfig) {
    this.radioButtons = config.radioButtons;

    this.init();
  }

  private radioButtons: RadioButtonGroupItem[];
  correlatedGroups: RadioButtonGroup[] = [];

  init() {
    this.radioButtons.forEach((radioButtonConfigItem, i) => {
      const radioButton = radioButtonConfigItem.button;
      radioButton.controller.setSelected(i === 0);
      radioButton.controller.onUserSelect = () => {
        // Select the button & deselect all other buttons.
        this.selectButton(radioButton);
        // Fire the button's callback.
        radioButtonConfigItem.callback();
        // Fire buttons in correlated groups if they exist.
        this.correlatedGroups.forEach((otherGroup) => {
          const buttonInOtherGroup = otherGroup.radioButtons.find(
            (button) =>
              button.button.controller.settingElement.key ===
              radioButton.controller.settingElement.key,
          );
          if (buttonInOtherGroup) {
            otherGroup.selectButton(buttonInOtherGroup.button);
          }
        });
      };
    });
  }

  selectButton(button: RadioButton) {
    this.radioButtons.forEach((rb) => {
      rb.button.controller.setSelected(rb.button === button);
    });
  }

  makeInteractive(isInteractive: boolean) {
    this.radioButtons.forEach((rb) => {
      rb.button.controller.makeInteractive(isInteractive);
    });
  }

  correlateWith(otherGroup: RadioButtonGroup) {
    this.correlatedGroups.push(otherGroup);
    otherGroup.correlatedGroups.push(this);
  }
}
